var MENTION_USER_LABEL_CLASSNAME = 'sendbird-mention-user-label';

export { MENTION_USER_LABEL_CLASSNAME as M };
//# sourceMappingURL=bundle-B5pWUwTI.js.map
